module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"URBAN TXT: TEEN EXPLORING TECHNOLOGY","short_name":"TXT","start_url":"/","background_color":"#ffffff","theme_color":"#2594A9","display":"standalone","icon":"static/favicon-32x32.png","icon_options":{"purpose":"any maskable"},"legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"b7fc11a0e0f6118a97a7db8d1b2e538a"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
